var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('page-sub-title');
import { breakpoints, theme } from '@shapeable/theme';
import { MarkdownContent } from './markdown-content';
export var PageSubTitleDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-weight: 300;\n    padding: ", " ", " 0;\n    margin: 0;\n    font-family: ", ";\n    color: ", ";\n    font-size: 1.8em;\n  "], ["\n    font-weight: 300;\n    padding: ", " ", " 0;\n    margin: 0;\n    font-family: ", ";\n    color: ", ";\n    font-size: 1.8em;\n  "])), theme.UNIT(2), theme.UNIT(3), theme.FONT('serif'), theme.COLOR('text')),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", " ", ";\n  "], ["\n    padding: ", " ", ";\n  "])), theme.UNIT(1), theme.UNIT(4)),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "]))),
  desktopLarge: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: 2em;\n  "], ["\n    font-size: 2em;\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var PageSubTitle = function PageSubTitle(props) {
  var className = props.className,
      children = props.children;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(MarkdownContent, {
    text: children
  }));
};
PageSubTitle.defaultProps = PageSubTitleDefaultProps;
PageSubTitle.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;